import { useFormik } from "formik";
import Header from "user/components/common/Header";
import { labelStyle } from "user/components/form/CategoryTab";
import InputField from "user/components/common/InputField";
import { usePostSendPassword } from "common/hooks/user/account/usePostSendPassword";
import { errorMsgHandler, regEmail } from "common/hooks/utils/utils";
import { ComplateOverlay, SystemPopup } from "user/components/common/Overlay";
import useOverlay, { OverlayWrapper } from "common/hooks/user/useOverlay";

type InitialValuesProps = {
    m_category: string;
    m_email: string;
};
const initialValues: InitialValuesProps = {
    m_category: "1",
    m_email: "",
};
export default function FindPassword() {
    const { overlay, openOverlay, closeOverlay } = useOverlay();
    const { mutate, isPending } = usePostSendPassword();

    const formik = useFormik({
        initialValues,
        onSubmit(values, formikHelpers) {
            formikHelpers.setSubmitting(true);
            onSubmit(values);
        },
        validate(values) {
            const errors: Record<string, string> = {};

            if (!values.m_email || !regEmail.test(values.m_email)) {
                errors.m_email = "이메일 주소를 확인하세요.";
            }

            return errors;
        },
        validateOnMount: true,
    });

    const errorKeys = Object.keys(formik.errors);
    const isInValid = errorKeys.length > 0;

    const onSubmit = (values: InitialValuesProps) => {
        // console.log(values);
        // 비밀번호 재설정 이메일 전송

        const body = {
            m_category: Number(values.m_category),
            m_email: values.m_email,
        };

        mutate(
            { ...body },
            {
                onSuccess: () => {
                    openOverlay(
                        <ComplateOverlay
                            headerTitle="이메일 전송"
                            title="비밀번호 재설정"
                            content={`회원가입 시 입력하신 이메일로 비밀번호\재설정을 위한 이메일을 전송했습니다.`}
                            extraContent={
                                <div className="text-[#999] text-center mt-[60px]">
                                    약간의 시간이 소요될 수 있습니다.
                                    <br />
                                    메일이 도착하지 않으셨을 경우
                                    <br />
                                    스팸 메일함을 확인해보세요.
                                </div>
                            }
                        />,
                    );
                },
                onError: (error: any) => {
                    const err_msg = errorMsgHandler(error);
                    let statusCode = error.response.data.statusCode;
                    if (statusCode === 404) {
                        formik.setFieldError("m_email", "가입된 이메일이 존재하지 않습니다.");
                    } else {
                        openOverlay(<SystemPopup message={err_msg} onClickClose={closeOverlay} />);
                    }
                },
            },
        );
    };

    return (
        <OverlayWrapper overlay={overlay} closeOverlay={closeOverlay}>
            <div className={`min-h-[100dvh] flex-col flex relative max-h-none`}>
                <Header goBack title="비밀번호 찾기" />
                <div className="wrapper flex flex-col py-[16px] flex-1 [&_form]:flex-1 [&_form]:flex [&_form]:flex-col">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="flex flex-col flex-1">
                            <div className="flex flex-col gap-[16px] flex-1">
                                {/* 회사/개인 선택 */}
                                <div role="group" className="bg-primary3 rounded-[8px] p-[4px] flex">
                                    <label htmlFor="1" className={labelStyle}>
                                        <input
                                            type="radio"
                                            id="1"
                                            name="m_category"
                                            value="1"
                                            checked={formik.values.m_category === "1"}
                                            onChange={e => {
                                                formik.setFieldValue("m_category", e.target.value);
                                            }}
                                            className="appearance-none"
                                        />
                                        회사
                                    </label>
                                    <label htmlFor="2" className={labelStyle}>
                                        <input
                                            type="radio"
                                            id="2"
                                            name="m_category"
                                            value="2"
                                            checked={formik.values.m_category === "2"}
                                            onChange={e => {
                                                formik.setFieldValue("m_category", e.target.value);
                                            }}
                                            className="appearance-none"
                                        />
                                        개인
                                    </label>
                                </div>

                                <div className={`flex flex-col`}>
                                    <label htmlFor="m_email" className="mb-[4px] text-[#484964] leading-[24px]">
                                        이메일
                                    </label>

                                    <InputField
                                        id="m_email"
                                        name="m_email"
                                        value={formik.values.m_email}
                                        onChange={formik.handleChange}
                                        placeholder="이메일을 입력해주세요"
                                        error={formik.touched.m_email && errorKeys.includes("m_email")}
                                        onClickClearButton={() => formik.setFieldValue("m_email", "")}
                                    />
                                    {formik.touched.m_email && formik.errors.m_email && (
                                        <div className="text-[#DC2626] flex gap-[6px] text-[14px] mt-[4px]">{formik.errors.m_email}</div>
                                    )}
                                </div>
                            </div>

                            <div className="flex flex-col gap-2">
                                <button
                                    data-disabled={isInValid}
                                    type="submit"
                                    className="shadow-custom bg-gradient-to-r from-[#273219] to-[#4B632B] text-white font-bold text-[18px] leading-[28px] py-[12px] rounded-[12px] data-[disabled='true']:opacity-[0.3]"
                                >
                                    완료
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </OverlayWrapper>
    );
}
